function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import map from 'lodash/map';
import every from 'lodash/every';
import takeWhile from 'lodash/takeWhile';
import takeRightWhile from 'lodash/takeRightWhile';
import trimStart from 'lodash/trimStart';
import { mapState, mapGetters } from 'vuex';
export default {
  created: function created() {
    this.addPivotIfNeeded();
  },
  mounted: function mounted() {
    // Preserve query when changing between collocations and matching expressions
    this.updateView();
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    elementsType: function elementsType(s) {
      return s.elements.type;
    },
    elements: function elements(s) {
      return s.elements.left;
    }
  })), mapGetters({
    isPresent: 'elements/at',
    resultType: 'api/formResultType'
  })), {}, {
    maxElements: function maxElements() {
      return this.$ncsConfig.result.collocations.elements.maximum;
    },
    leftElementsLength: function leftElementsLength() {
      if (every(this.elements, this.isStar)) {
        return 0;
      } else {
        return Math.min(takeWhile(this.elements, this.isStar).length, this.maxElements - 1);
      }
    },
    rightElementsLength: function rightElementsLength() {
      return Math.min(takeRightWhile(this.elements, this.isStar).length, this.maxElements - 1);
    },
    pivotElements: function pivotElements() {
      return this.elements.slice(this.leftElementsLength, this.elements.length - this.rightElementsLength);
    }
  }),
  watch: {
    elements: function elements() {
      this.updateView();
    }
  },
  methods: {
    isStar: function isStar(element) {
      return element.unit.value === '*';
    },
    onChange: function onChange() {
      var elements = [];
      var words = trimStart(this.$refs.input.value).split(/ +/).filter(function (w) {
        return w !== '';
      });
      var wordsLength = Math.min(words.length, this.maxElements - 1); // Number of units must be one less than total maximum

      var rightElements = Math.min(this.$refs.rightElements.value, this.maxElements - wordsLength);
      var leftElements = Math.min(this.$refs.leftElements.value, this.maxElements - wordsLength - rightElements);

      for (var i = 0; i < leftElements; ++i) {
        elements.push({
          unit: {
            value: '*'
          }
        });
      } // If words is empty we insert an empty element


      if (wordsLength === 0) {
        elements.push({
          unit: {
            value: null
          }
        });
      } else {
        for (var _i = 0; _i < wordsLength; ++_i) {
          elements.push({
            unit: {
              value: words[_i]
            }
          });
        }
      }

      for (var _i2 = 0; _i2 < rightElements; ++_i2) {
        elements.push({
          unit: {
            value: '*'
          }
        });
      }

      this.setElements(elements);
    },
    updateView: function updateView() {
      this.$refs.leftElements.value = this.leftElementsLength;
      this.$refs.rightElements.value = this.rightElementsLength;
      this.addPivotIfNeeded();
      this.setInputText(map(this.pivotElements, 'unit.value').join(' '));
    },
    addPivotIfNeeded: function addPivotIfNeeded() {
      if (this.pivotElements.length === 0) {
        this.$store.commit('elements/addElement', {
          side: 'left',
          index: 0
        });
      }
    },
    setElements: function setElements(elements) {
      this.$store.commit('elements/setElements', {
        left: elements
      });
    },
    setInputText: function setInputText(text) {
      if (!this.$refs.input) return;
      var finalSpace = this.$refs.input.value[this.$refs.input.value.length - 1] === ' ';
      this.$refs.input.value = text + (finalSpace ? ' ' : '');
    }
  }
};